var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4Contactssvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.4 7.2A1.6 1.6 0 10.8 5.6c0 .882.718 1.6 1.6 1.6zm11.2 0A1.6 1.6 0 1012 5.6c0 .882.717 1.6 1.6 1.6zm.8.8h-1.6c-.44 0-.838.177-1.128.465A3.657 3.657 0 0113.55 11.2h1.65a.8.8 0 00.8-.8v-.8A1.6 1.6 0 0014.4 8zM8 8a2.8 2.8 0 100-5.6 2.799 2.799 0 00-2.8 2.8C5.2 6.747 6.452 8 8 8zm1.92.8h-.207c-.52.25-1.098.4-1.713.4s-1.19-.15-1.713-.4H6.08a2.88 2.88 0 00-2.88 2.88v.72a1.2 1.2 0 001.2 1.2h7.2a1.2 1.2 0 001.2-1.2v-.72A2.88 2.88 0 009.92 8.8zm-5.593-.335A1.595 1.595 0 003.2 8H1.6A1.6 1.6 0 000 9.6v.8a.8.8 0 00.8.8h1.647a3.666 3.666 0 011.88-2.735z",
    fill: "#9FA2B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Contactssvg);
export default __webpack_public_path__ + "static/media/_4Contactssvg.c44d5a068075999f01b4ee1d1c657c50.svg";
export { ForwardRef as ReactComponent };